module.exports = __webpack_public_path__ + "a676f6a692b44c743f77c542494acedd.pdf";